import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import SectionIntro from "./SectionIntro";

const FAQ = () => {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true });
  const list = Array.isArray(items) ? items : [];
  const [openIndex, setOpenIndex] = useState(0);

  // FAQPage structured data for Google rich results
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: list.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  };

  return (
    <section className="bg-cream py-24 md:py-32">
      {list.length > 0 && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify(faqSchema)}
          </script>
        </Helmet>
      )}
      <div className="max-w-3xl mx-auto px-5 md:px-8">
        <SectionIntro
          eyebrow={t("faq.eyebrow")}
          title={t("faq.title")}
          className="mb-14 md:mb-16"
        />

        <div className="border-t border-ink/10">
          {list.map((item, i) => {
            const isOpen = openIndex === i;
            return (
              <div key={i} className="border-b border-ink/10">
                <button
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-6 py-6 text-left group"
                  aria-expanded={isOpen}
                >
                  <span className="font-serif text-xl md:text-2xl font-light text-ink group-hover:text-brass transition-colors duration-300">
                    {item.q}
                  </span>
                  <motion.span
                    animate={{ rotate: isOpen ? 45 : 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-brass text-3xl font-light leading-none flex-shrink-0"
                  >
                    +
                  </motion.span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.3, ease: "easeInOut" }}
                      className="overflow-hidden"
                    >
                      <p className="pb-6 text-ink-soft font-light leading-relaxed max-w-2xl">
                        {item.a}
                      </p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQ;
